export default [
  {
    path: '/project/:alias/:projectAlias/setting/approver',
    component: () => import(`./pages/page-merge-request-rules.vue`)
  },
  {
    path: '/team/:teamAlias/setting/approver',
    component: () => import(`./pages/page-team-merge-request-approver.vue`)
  },
  {
    path: '/company/:companyAlias/setting/approver',
    component: () => import(`./pages/page-company-merge-request-approver.vue`)
  }
];
